import React from 'react';
import platform from "Pub/js/platform";
const { NCTooltip } = platform.base;

export default class TooltipText extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            showTip: false
        }
    }

    render() {
        const { text, className } = this.props;
        const { showTip } = this.state;
        const textNode = <span
            className={`tooltip-text ${className}`}
            onMouseEnter={(e) => {
                // console.log('进入', text);
                const tipNode = e.target;
                if (tipNode) {
                    if (tipNode.scrollWidth > tipNode.clientWidth) {
                        !showTip && this.setState({ showTip: true })
                    }
                }
            }}
            onMouseLeave={(e) => {
                // console.log('离开', text);
                showTip && this.setState({
                    showTip: false
                })
            }}
        >
            {text}
        </span>
        return <NCTooltip
            placement="bottom"
            overlay={text}
            visible={showTip}
            inverse
        >
            {textNode}
        </NCTooltip>
    }
}